import { Button, Dialog, DialogTitle, Divider, TextField, Typography } from "@material-ui/core";
import { createStyles, makeStyles, styled, Theme, withStyles } from "@material-ui/core/styles";
import * as React from "react";
import * as ThemeConstants from "../../Styles/Constants";
import { useDispatch, useSelector } from "react-redux";
import { ReduxState, SnackbarStatus } from "../../Definitions/Definitions";
import { openSnackbar } from "../../Actions/ActionFunctions";
import { useWindowDimensions } from "../UI/UseWindowDimensions";
import { useHistory } from "react-router";
import { RouteLink } from "../UI/RouteLink";

const VERSION = "2.0";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            justifyContent: "center",
            height: "100vh",
            width: "100vw",
            position: "fixed",
            top: 0,
            left: 0
        },
        lobbyButtons: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "1rem",
            marginTop: "1rem"
        },
        textFlex: {
            display: "flex",
            alignItems: "flex-end",
            WebkitAlignItems: "flex-end",
            justifyContent: "left",
            gap: "1rem"
        },
    })
);

const StyledTextField = withStyles({
    root: {
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: ThemeConstants.PALETTE_DARK_WHITE,
                borderWidth: "2px"
            },
            '&:hover fieldset': {
                borderColor: ThemeConstants.PALETTE_WHITE,
                borderWidth: "3px"
            },
            '&.Mui-focused fieldset': {
                borderColor: ThemeConstants.PALETTE_WHITE,
                borderWidth: "3px"
            },
        },
    },
})(TextField);

export const HomePage = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const { width, height } = useWindowDimensions();

    const [roomId, setRoomId] = React.useState(0);
    const [dialogOpen, setDialogOpen] = React.useState(false);

    const validateRoomId = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (e.target.value == "") {
            setRoomId(0);
            return;
        }

        const parsed = parseInt(e.target.value);
        if (!isNaN(parsed))
            setRoomId(parsed);
    }

    const joinLobby = () => {
        if (roomId == 0) {
            dispatch(openSnackbar(SnackbarStatus.Error, "Please input a room code", 2000));
            return;
        }

        setDialogOpen(false);
        history.push(`/join/${roomId}`)
    }

    const createLobby = () => {
        history.push(`/join/new`);
    }

    const onKeyDown = (e: React.KeyboardEvent) => {
        if (e.key == "Enter" && roomId != 0) {
            joinLobby();
        }
    }

    return (
        <div className={classes.root}>
            <div className={classes.textFlex}>
                <Typography variant="h6" style={{ visibility: "hidden" }}>v{VERSION}</Typography> {/* Duplicate version text to recenter the title element */}
                <Typography variant="h2"><b>Word Arena</b></Typography>
                <Typography variant="h6" style={{ paddingBottom: width < 600 ? "0.2rem" : "0.4rem" }}>v{VERSION}</Typography>
            </div>
            <RouteLink route="/about">New to the arena?</RouteLink>
            <Button color="secondary" style={{ marginTop: "1.5rem" }} onClick={createLobby} variant="outlined">
                Create New Room
            </Button>
            <Button color="primary" style={{ marginTop: "0.5rem" }} onClick={() => setDialogOpen(true)} variant="outlined">
                Join Room
            </Button>

            <Dialog open={dialogOpen} fullWidth maxWidth={'sm'}>
                <DialogTitle>Join a room</DialogTitle>
                <div style={{ display: "flex", alignItems: "center", flexDirection: "column", gap: "1rem", marginBottom: "1rem" }}>
                    <StyledTextField
                        label={roomId == 0 ? "Room Code" : ""}
                        variant="outlined"
                        autoFocus
                        style={{ width: "95%" }}
                        inputProps={{
                            style: { fontSize: "25px" },
                            maxLength: 6
                        }}
                        InputLabelProps={{
                            style: {
                                fontSize: "25px",
                                color: ThemeConstants.PALETTE_LIGHT_GREY
                            },
                            shrink: false
                        }}
                        value={roomId == 0 ? "" : roomId}
                        onKeyDown={onKeyDown}
                        onChange={validateRoomId}
                    />
                    <div style={{ display: "flex", gap: "1rem" }}>
                        <Button onClick={joinLobby} disabled={roomId == 0} variant="contained" color="primary">
                            Join
                        </Button>
                        <Button onClick={() => setDialogOpen(false)} variant="contained" color="secondary">
                            Cancel
                        </Button>
                    </div>
                </div>
            </Dialog>
        </div>
    );
}